<script lang="ts" setup>
const props = withDefaults(defineProps<{
    enabled?: boolean;
    top?: boolean;
    hideScroll?: boolean;
    naturalHeight?: boolean;
    tableOverflow?: boolean;
}>(), {
    enabled: true,
    top: false,
    hideScroll: false,
    naturalHeight: false,
    tableOverflow: false
});

const $attrs = useAttrs();
const attrs = () => only($attrs, 'class', 'style');
const responsiveClasses = "relative -my-px before:absolute before:top-1/2 before:-mt-1.5 before:hidden before:h-2.5 before:text-ui-helper/none before:text-fg before:content-['‹'] after:absolute after:top-1/2 after:-mt-1.5 after:hidden after:h-2.5 after:text-ui-helper/none after:text-fg after:content-['›'] dark:before:text-fg-dark dark:after:text-fg-dark";
const wrapperClasses = 'wrapper light block box-content whitespace-nowrap [-ms-overflow-style:-ms-autohiding-scrollbar] [-webkit-overflow-scrolling:touch]';
const wrapperSizeClasses = computed(() => props.naturalHeight ? 'w-full' : 'size-full');
const wrapperOverflowClasses = computed(() => props.naturalHeight ? 'overflow-y-hidden' : props.top ? 'overflow-y-auto' : 'overflow-y-hidden');
const wrapperHorizontalOverflowClasses = computed(() => props.tableOverflow ? 'overflow-x-clip max-lg:overflow-x-auto' : 'overflow-x-auto');
const scrollHideClasses = '[-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden';

const scroll = ref<HTMLDivElement | null>(null);
const left = ref(false);
const right = ref(false);

const handleScroll = () =>
{
    if (props.enabled)
    {
        left.value = scroll.value?.scrollLeft > 0;
        right.value = scroll.value?.scrollWidth - (scroll.value?.scrollLeft + scroll.value?.clientWidth) > 0;
    }
    else
    {
        left.value = false;
        right.value = false;
    }
};

onMounted(() =>
{
    handleScroll();

    nextTick(() =>
    {
        handleScroll();
    });

    if (scroll.value)
    {
        scroll.value.addEventListener('scroll', handleScroll);
    }
});

onUnmounted(() =>
{
    if (scroll.value)
    {
        scroll.value.removeEventListener('scroll', handleScroll);
    }
});

</script>

<template>
    <div
        v-bind="attrs()"
        :class="[
            enabled ? responsiveClasses : '',
            top ? 'top' : '',
            left ? 'scroll-before before:-start-2.5 before:block' : '',
            right ? 'scroll-after after:-end-2.5 after:block' : ''
        ]"
    >
        <div
            ref="scroll"
            :class="[
                enabled ? wrapperClasses : '',
                wrapperSizeClasses,
                wrapperHorizontalOverflowClasses,
                hideScroll ? scrollHideClasses : '',
                wrapperOverflowClasses
            ]"
        >
            <div class="inner">
                <slot />
            </div>
        </div>
    </div>
</template>
